import { FieldConfig } from "@/components/form-builder";

export const signUpFormFields: FieldConfig[] = [
  {
    name: "fullName",
    type: "text",
    label: "Seu nome completo",
    required: false,
    placeholder: "Digite seu nome completo",
    colSpan: 2,
  },
  {
    name: "cpf",
    type: "cpf",
    label: "Seu CPF",
    required: false,
    placeholder: "Digite número do seu CPF",
    colSpan: 2,
  },
  {
    name: "email",
    type: "email",
    label: "Seu email principal",
    required: false,
    placeholder: "Digite seu email",
    colSpan: 2,
  },
  {
    name: "password",
    type: "password",
    label: "Senha",
    required: false,
    placeholder: "Digite sua senha",
    colSpan: 2,
  },
]